/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { z } from "zod";

export const getFonctionsHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations.")
      })

/**
 * @description La liste des fonctions est retournée avec succès.
 */
export const getFonctions200Schema = z.array(z.string())

/**
 * @description Réponse d\'erreur standard
 */
export const getFonctions500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getFonctionsQueryResponseSchema = z.lazy(() => getFonctions200Schema)